<nav #dropdownMenuParent class="top-nav">
  <a (click)="closeAllDropDowns()"
     [routerLink]="URLS.root"
     class="brand">
    <img [src]="BRAND.logo.main" alt="logo" class="brand-logo" height="40" width="40"/>
    <h2>{{ BRAND.name }}</h2>
  </a>
  <div class="left-item-wrapper">
    <a (click)="dropdownMenuProducts.toggleDropdown(); closeOtherDropDowns(dropdownMenuProducts)"
       (mouseenter)="dropdownMenuProducts.openDropdown(); closeOtherDropDowns(dropdownMenuProducts)">
      <app-dropdown-menu
          #dropdownMenuProducts
          [dropdownParent]="dropdownMenuParent"
          [minimumColumns]="4"
          [productLines]="PRODUCT_LINES">
        <span i18n="@@landingLayoutTopNav.products">Products</span>
        <i [class]="'caret fas fa-fw ' + (!dropdownMenuProducts.isDropdownOpen ? 'fa-chevron-down' : 'fa-chevron-up')"
           aria-hidden="true"></i>
      </app-dropdown-menu>
    </a>
    <a (click)="dropdownMenuLibraries.toggleDropdown(); closeOtherDropDowns(dropdownMenuLibraries)"
       (mouseenter)="dropdownMenuLibraries.openDropdown(); closeOtherDropDowns(dropdownMenuLibraries)">
      <app-dropdown-menu
          #dropdownMenuLibraries
          [dropdownParent]="dropdownMenuParent"
          [minimumColumns]="2"
          [productLines]="LIBRARIES">
        <span i18n="@@landingLayoutTopNav.libraries">Libraries</span>
        <i [class]="'caret fas fa-fw ' + (!dropdownMenuLibraries.isDropdownOpen ? 'fa-chevron-down' : 'fa-chevron-up')"
           aria-hidden="true"></i>
      </app-dropdown-menu>
    </a>
    <a (click)="dropdownMenuPlugins.toggleDropdown(); closeOtherDropDowns(dropdownMenuPlugins)"
       (mouseenter)="dropdownMenuPlugins.openDropdown(); closeOtherDropDowns(dropdownMenuPlugins)">
      <app-dropdown-menu
          #dropdownMenuPlugins
          [dropdownParent]="dropdownMenuParent"
          [minimumColumns]="1"
          [productLines]="PLUGINS">
        <span i18n="@@landingLayoutTopNav.plugins">Plugins</span>
        <i [class]="'caret fas fa-fw ' + (!dropdownMenuPlugins.isDropdownOpen ? 'fa-chevron-down' : 'fa-chevron-up')"
           aria-hidden="true"></i>
      </app-dropdown-menu>
    </a>
    <a (click)="dropdownMenuServices.toggleDropdown(); closeOtherDropDowns(dropdownMenuServices)"
       (mouseenter)="dropdownMenuServices.openDropdown(); closeOtherDropDowns(dropdownMenuServices)">
      <app-dropdown-menu #dropdownMenuServices [dropdownParent]="dropdownMenuParent" [productLines]="SERVICES">
        <span i18n="@@landingLayoutTopNav.services">Services</span>
        <i [class]="'caret fas fa-fw ' + (!dropdownMenuServices.isDropdownOpen ? 'fa-chevron-down' : 'fa-chevron-up')"
           aria-hidden="true"></i>
      </app-dropdown-menu>
    </a>
    <a (click)="closeDropdowns([dropdownMenuProducts, dropdownMenuLibraries, dropdownMenuServices])"
       [routerLink]="URLS.about">
      <span i18n="@@landingLayoutTopNav.about">About</span>
    </a>
  </div>
  <div class="right-item-wrapper">
    <a (click)="closeDropdowns([dropdownMenuProducts, dropdownMenuLibraries, dropdownMenuServices])"
       [href]="'https://portal.opentemplatehub.com'"
       class="startup-portal" target="_blank">
      <i [class]="'fas fa-fw fa-arrow-up-right-from-square'" aria-hidden="true"></i>
      <span i18n="@@landingLayoutTopNav.contactUs"> Startup Portal</span>
    </a>
  </div>
</nav>
